// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KPvp","icon":"styles_icon__26zHV"};